<div class="wrapper">
  <div class="text">
    <ng-content></ng-content>
  </div>
</div>